module.exports = __webpack_public_path__ + "static/media/teknon@2x.18def4f6.jpg";